import React, { useState } from "react";
import "./BugReport.css";
import { createBug } from "./bugService";

function BugReportPage({user}) {

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    expected_behavior: "",
    user_impact: "",
    platform_id: 1
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {

        try {

            const newBug = await createBug(formData, user);

            alert("Thanks! Your bug report has been submitted.");

            setFormData({
                title: "",
                description: "",
                expected_behavior: "",
                user_impact: "",
                platform_id: 1
            });

        } catch (err) {

            console.error(err);

            alert("Unable to submit bug.");

        }

    };
  return (
    <div className="page-container">
      <div className="page-content">

        <h1>🐞 Report a Problem</h1>

        <p className="page-subtitle">
          Found something that isn't working?
          Tell us what happened and we'll take it from there.
        </p>

        <hr />

        <div className="bug-form">

          <label>What went wrong?</label>

          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Brief summary"
          />

          <label>Tell us what happened.</label>

          <textarea
            rows="6"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Describe what happened..."
          />

          <label>What did you expect?</label>

          <textarea
            rows="4"
            name="expected_behavior"
            value={formData.expected_behavior}
            onChange={handleChange}
            placeholder="What should have happened?"
          />

          <label>How much did this interrupt you?</label>

          <div className="radio-group">

            <label>
              <input
                type="radio"
                name="user_impact"
                value="noticed"
                checked={formData.user_impact === "noticed"}
                onChange={handleChange}
              />
              I noticed it.
            </label>

            <label>
              <input
                type="radio"
                name="user_impact"
                value="slowed_me_down"
                checked={formData.user_impact === "slowed_me_down"}
                onChange={handleChange}
              />
              It slowed me down.
            </label>

            <label>
              <input
                type="radio"
                name="user_impact"
                value="blocked"
                checked={formData.user_impact === "blocked"}
                onChange={handleChange}
              />
              I couldn't finish what I was doing.
            </label>

          </div>

          <label>Platform</label>

          <select
            name="platform_id"
            value={formData.platform_id}
            onChange={handleChange}
          >
            <option value={1}>Web</option>
            <option value={2}>Android</option>
            <option value={3}>iPhone</option>
            <option value={4}>iPad</option>
          </select>

          <button
            className="submit-button"
            onClick={handleSubmit}
          >
            Submit Problem
          </button>

        </div>

      </div>
    </div>
  );
}

export default BugReportPage;